module.exports = __webpack_public_path__ + "static/img/logo.71b8d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logo.png
// module id = 8Fi2
// module chunks = 21